import { createElement } from 'react';
import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendModule,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import ChatIcon from '@material-ui/icons/Chat';
import { AssistantRoot } from './components/AssistantDock';
import { AssistantClient, assistantApiRef } from './api';

const assistantApi = ApiBlueprint.make({
  name: 'assistant',
  params: defineApi =>
    defineApi({
      api: assistantApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AssistantClient(discoveryApi, fetchApi),
    }),
});

const assistantPage = PageBlueprint.make({
  name: 'root',
  params: {
    path: '/assistant',
    title: 'Assistant',
    icon: createElement(ChatIcon),
    loader: () =>
      import('./components/AssistantPage').then(m =>
        createElement(m.AssistantPage),
      ),
  },
});

// The dock beside every page. It wraps the app inside sign-in and the router,
// so it only renders for a signed-in user and can follow navigation. App root
// wrappers must come from a module for the `app` plugin, not this plugin.
const assistantDock = AppRootWrapperBlueprint.make({
  name: 'dock',
  params: {
    component: ({ children }) => createElement(AssistantRoot, null, children),
  },
});

export const assistantPlugin = createFrontendPlugin({
  pluginId: 'assistant',
  extensions: [assistantApi, assistantPage],
});

/** Install next to `assistantPlugin` to dock the assistant beside every page. */
export const assistantDockModule = createFrontendModule({
  pluginId: 'app',
  extensions: [assistantDock],
});
